require( 'vrview/build/vrview' );


/** WEBPACK FOOTER **
 ** ./public/jssrc/vrview.js
 **/